<template>
	<div class="wrapper">
		<div>
			<md-table md-card>
				<md-table-toolbar>
					<md-field>
						<md-select v-model="form_current_created_type" name="created_type" placeholder="current_created_type">
							<md-option value="model">model</md-option>
							<md-option value="popular">popular</md-option>
							<md-option value="extract">extract</md-option>
						</md-select>
					</md-field>
				</md-table-toolbar>

				<md-table-row>
					<!-- <md-table-head>id</md-table-head> -->
					<md-table-head>id</md-table-head>
					<md-table-head>created_type</md-table-head>
					<md-table-head>jp</md-table-head>
					<md-table-head>en</md-table-head>
					<md-table-head v-if="is_model">model_index</md-table-head>
					<!-- <md-table-head v-if="is_model">ios_icon</md-table-head>
					<md-table-head v-if="is_model">web_icon</md-table-head> -->
					<md-table-head v-if="is_popular">highly_recommeded</md-table-head>
					<md-table-head v-if="is_model_or_popular">sepcial_keywords</md-table-head>
					<md-table-head v-if="is_model_or_popular">sepcial_domains</md-table-head>
					<md-table-head>used_count</md-table-head>
				</md-table-row>

				<DefaultTag
					v-for="default_tag in list"
					:body="default_tag"
					:key="default_tag.id"
				/>
			</md-table>
			<DefaultTagForm/>
		</div>
	</div>
</template>
<script>
import DefaultTag from './DefaultTag'
import DefaultTagForm from './DefaultTagForm'

export default {
	name: 'DefaulTags',
	data() {
    return {
			form_current_created_type: 'model' // initial value
    };
	},
	watch: {
		form_current_created_type: {
			immediate: true,
			handler(val) {
				this.$store.commit('default_tags/set_selected', '')
				this.$store.commit('default_tags/set_current_created_type', val)
			},
		},
	},
	computed: {
		list: function () {
			return this.$store.getters['default_tags/list']
		},
		is_model: function () {
			return this.$store.getters['default_tags/is_model']
		},
		is_model_or_popular: function () {
			return this.$store.getters['default_tags/is_model_or_popular']
		},
		is_popular: function () {
			return this.$store.getters['default_tags/is_popular']
		},
	},
  methods: {

	},
	created() {
		console.log('created')
		this.$store.dispatch('default_tags/init')
		this.$store.dispatch('default_tags/startListener')
	},
	components: {
		DefaultTag,
		DefaultTagForm
  },
}
</script>
<style scoped>
.wrapper {
	margin: 10px;
}
</style>
